// src/components/Header.jsx  ← FINAL VERSION
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Header = () => {
    const { cart } = useCart();
    const navigate = useNavigate();


    const scrollToSection = (sectionId) => {
        // If we're not on homepage, go there first (client-side!)
        // Special case for FAQ page
        if (sectionId === 'faq-page') {
            if (window.location.pathname === '/faq') {
                // Already on FAQ → scroll to top
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                // Go to FAQ page
                navigate('/faq');
            }
            return; // Stop here — no need to process homepage scroll
        }


        if (window.location.pathname !== '/') {
            navigate('/');
            // Wait for homepage to load, then scroll
            setTimeout(() => {
                const el = document.getElementById(sectionId);
                el?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        } else {
            // Already on homepage → just scroll
            document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <header className="header">
            <div className="container header-container">
                <Link to="/" className="logo">Zenzzz</Link>
                <nav className="nav">
                    <button onClick={() => scrollToSection('features')} className="nav-link">
                        Why Zenzzz?
                    </button>

                    <button onClick={() => scrollToSection('faq-page')} className="nav-link">
                    FAQ
                </button>



                    <button onClick={() => scrollToSection('blog')} className="nav-link">
                        Sleep Insights
                    </button>
                    <button onClick={() => scrollToSection('testimonials')} className="nav-link">
                        Reviews
                    </button>
                    <button onClick={() => scrollToSection('cart')} className="nav-link">
                        Cart ({cart.quantity})
                    </button>
                </nav>
            </div>
        </header>
    );
};

export default Header;